import { useMemo } from 'react'

let counter = 0

// Generates a unique identifier on mount
const useUniqueId = () => useMemo(() => ++counter, [])

export default useUniqueId
